import { ActionSchema, DynamicStringSchema } from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { ActionButton } from './ActionButton';

interface ResolvedProps {
  readonly label: string;
  readonly variant?: string;
  readonly action?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  label: DynamicStringSchema,
  variant: DynamicStringSchema,
  action: ActionSchema,
}) as any;

export const ActionButtonImpl = createComponentImplementation(
  { name: 'ActionButton', schema },
  // GenericBinder resolves `action` (Action object in JSON) to a () => void closure
  // that calls context.dispatchAction(), which fires surface.onAction.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ props }: { props: ResolvedProps; buildChild: any; context: any }) => (
    <ActionButton
      label={props.label ?? ''}
      variant={props.variant as 'primary' | 'subtle' | undefined}
      onClick={props.action ?? (() => undefined)}
    />
  )
);
